import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import classNames from 'classnames'
import moment from 'moment'

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';

import Header from '@components/Header';
import DetailUploadModal from '@components/Users/DetailUploadModal';

import { getListInternalUserLoads, getTotalBulkLoad, getDetailLoadInternal, rejectUpload, executeUpload } from '@actions/users';
import { getBusiness } from '@actions/business';
import { sendActionToBitacora  } from '@actions/bitacora';

import { StatusBulkLoad, StatusString, LANGUAGE_DEFAULT } from '@constants/general'

import { getValueLanguageObj } from '@utils/general'
import { canNavigateAllCountries, getAllowedCountries } from '@utils/countryPermissions';

import './style.scss'

class BulkLoadInternals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: {
        isVisible: false,
        title: '',
        children: null,
        textOk: '',
        textHide: '',
        actionOk: null,
        actionHide: () => {},
      },
      users: [],
      loading: false,
      loadingBtn: false,
      totalRecords: 0,
      lazyParams: {
        first: 0,
        rows: 10,
        page: 0,
      },
      type: 'internal',
      typeCountry: null,
      typeCompany: null,
      typeStatus: null,
      searchValues: {
        country: null,
        status: null,
      },
      showModalDetailUpload: {
        isVisible: false,
        data: {},
      },
      countryRequired: false,
      companyRequired: false,
      catalogCompanies: []
    };
    this.catalogStatus = [
      {label: this.props.t('Todos') , id: StatusBulkLoad.STATUS_ALL },
      {label: this.props.t('En proceso') , id: StatusBulkLoad.STATUS_IN_PROCESS },
      {label: this.props.t('Pendiente') , id: StatusBulkLoad.STATUS_PENDING },
      {label: this.props.t('En ejecución') , id: StatusBulkLoad.STATUS_IN_ACTION },
      {label: this.props.t('Cancelado') , id: StatusBulkLoad.STATUS_CANCELLED },
      {label: this.props.t('Rechazado') , id: StatusBulkLoad.STATUS_REJECTED },
      {label: this.props.t('Terminado') , id: StatusBulkLoad.STATUS_FINISHED }
    ]
  }

  componentDidMount() {
    const { history, countriesCurrentCatalog, canViewAllCountries } = this.props;
    const inheritedCountry = history.location.state?.typeCountry;
    const typeCountry = countriesCurrentCatalog.find(country => country.id === inheritedCountry?.id);

    if (typeCountry) {
      this.setState({ typeCountry }, async () => {
        const companies = await this.seCompaniesByCountry();
        if (!companies || this.state.typeCountry?.id !== typeCountry.id) return;
        const typeCompany = companies.find(company => company.id === history.location.state?.typeCompany?.id) || null;
        this.setState({ typeCompany }, this.searchData);
      });
    } else if (canViewAllCountries) {
      this.loadData(true);
    }
  }

  searchData = () => {
    const { typeCountry, typeStatus, typeCompany } = this.state
    this.setState({
      searchValues: {
        country: typeCountry?.id || '',
        company: typeCompany?.id || '',
        status: typeStatus?.id || '',
      },
    }, () => this.loadData())
  }

  // loadTotal = async () => {
  //   const { getTotalBulkLoad } = this.props
  //   const { type, searchValues } = this.state
  //   this.setState({ loading: true });
  //   const querys = {
  //     type,
  //     status: searchValues.status || StatusBulkLoad.STATUS_SHOWABLE
  //   }
  //   if (searchValues.country) querys.country = searchValues.country

  //   const response = await getTotalBulkLoad(querys);
  //   if (!response?.status) {
  //     this.setState({
  //       totalRecords: response.total
  //     });
  //     this.loadData()
  //   }
  // }

  loadData = async (initLoad = false) => {
    const { getListInternalUserLoads, countriesCurrentCatalog, canViewAllCountries } = this.props;
    const { lazyParams, searchValues } = this.state;
    if ((initLoad && !canViewAllCountries) || (!initLoad && !countriesCurrentCatalog.some(country => country.id === searchValues.country))) {
      return this.setState({ countryRequired: true, users: [], loading: false });
    }
    const requestId = this.loadsRequestId = (this.loadsRequestId || 0) + 1;
    this.setState({ loading: true });
    const querys = {
      // page: lazyParams.page,
      // rows: lazyParams.rows,
      status: searchValues.status || StatusBulkLoad.STATUS_ALL

    };
    if (searchValues.country) querys.country = searchValues.country
    querys.company = searchValues.company ? searchValues.company : -1

    if (initLoad) {
      querys.country = -1
      querys.company = -1
    }

    console.log('querys', querys)
    const response = await getListInternalUserLoads(querys);
    if (requestId !== this.loadsRequestId) return;
    if (!response?.status) {
      return this.setState({
        users: response.data,
        loading: false,
      });
    }
    return this.setState({
      users: [],
      loading: false,
    });
    return this.setState({ loading: false });
  };

  seCompaniesByCountry = async () => {
    const { getBusiness, countriesCurrentCatalog } = this.props
    const { typeCountry } = this.state
    const requestId = this.companiesRequestId = (this.companiesRequestId || 0) + 1;
    this.setState({catalogCompanies: []})
    if (!countriesCurrentCatalog.some(country => country.id === typeCountry?.id)) return;
    const params = {
      type: 'visible',
      country: typeCountry?.id || ''
    };
    const response = await getBusiness(params);
    if (requestId !== this.companiesRequestId || this.state.typeCountry?.id !== typeCountry.id) return;
    if (!response?.status) {
      const catalogCompanies = response.data.map(item => ({ label: item.nombre, id: item.id }))
      this.setState({catalogCompanies});
      return catalogCompanies;
    }

  }

  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    console.log('event onPage', event);
    this.setState({ lazyParams: _lazyParams }, this.loadLazyData);
  };

  onSort = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    console.log('event onSort', event);
    this.setState({ lazyParams: _lazyParams });
  };

  onChangeSearch = (e) => {
    console.log(e);
    const { searchValues } = this.state;
    this.setState({
      searchValues: { ...searchValues, [e.target.name]: e.value },
    });
  };

  getDetailUpload = async (data) => {
    const { getDetailLoadInternal } = this.props
    await getDetailLoadInternal(data)
  }
  
  uploadDateTemplate = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {moment(rowData.fecha_carga).locale(this.props.i18n.language).format("DD MMMM YYYY hh:mm") }
    </>
  )

  countryTemplate = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {getValueLanguageObj(JSON.parse(rowData.pais))}
    </>
  )

  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  statusTemplate = (node, detail) => {
    const { t } = this.props
    let descError = ''
    if (node.desc_error) {
      descError = (
        <Button type="button" icon="pi pi-envelope" className="p-button-text p-button-primary" tooltip={node.desc_error} tooltipOptions={{position: 'top'}}/>
      )
    }
    if (node.estatus === 'En proceso') {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <div>
            <span className="badge-yellow" aria-hidden="true"> {t('En proceso').toUpperCase()} </span>
            {descError}
          </div>
        </>
      );
    }
    if (node.estatus === 'En ejecución') {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-green" aria-hidden="true"> {t('En ejecución').toUpperCase()} </span>
        </>
      );
    }
    if (node.estatus === 'Pendiente') {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className="badge-blue cursor-pointer" aria-hidden="true" onClick={() => this.openModalDetilUpload(node)}> {t('Pendiente').toUpperCase()} </span>
        </>
      );
    }
    if (node.estatus === 'Cancelado') {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <div className="p-d-flex p-ai-center">
            <span className="badge-red" aria-hidden="true">
              {t('Cancelado').toUpperCase()}
            </span>
            {descError}
          </div>
        </>
      );
    }
    if (node.estatus === 'Terminado') {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <div>
            <span aria-hidden="true"> {t('Terminado').toUpperCase()} </span>
            {descError}
          </div>
        </>
      );
    }
    if (node.estatus === 'Rechazado') {
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <div>
            <span aria-hidden="true"> {t('Rechazado').toUpperCase()} </span>
            {descError}
          </div>
        </>
      );
    }
  }

  detailTemplate = (rowData, detail) => (
    <>
      <span className="p-column-title">{detail.header}</span>
      <Button
        icon="pi pi-download"
        className=" p-button-text p-button-primary p-mr-2"
        onClick={() => this.getDetailUpload(rowData)}
      />
    </>
  );
  
  openModalDetilUpload = (data) => {
    this.setState({
      showModalDetailUpload: {
        isVisible: true,
        data
      }
    })

  }

   
  onChange = ({target}) => {
    if (target.name === 'typeCountry') {
      const typeCountry = this.props.countriesCurrentCatalog.find(country => country.id === target.value?.id) || null;
      this.companiesRequestId = (this.companiesRequestId || 0) + 1;
      this.loadsRequestId = (this.loadsRequestId || 0) + 1;
      this.setState({
        typeCountry,
        typeCompany: null,
        catalogCompanies: [],
        users: [],
        loading: false,
        countryRequired: false,
        companyRequired: false,
        searchValues: { ...this.state.searchValues, country: null, company: null },
      }, () => {
        if (typeCountry) this.seCompaniesByCountry();
      });
      return;
    }
    this.setState({[target.name]: target.value}, () => {
      if (target.name === "typeCompany") {
        this.setState({companyRequired: false})
      }
    });
  };

  onHideModal = () => {
    this.setState({
      showModal: {
        isVisible: false,
        actionHide: () => {},
      },
    });
  };

  onSuspendUpload = async (data, justification) => {
    const { t, rejectUpload, sendActionToBitacora } = this.props
    this.setState({loadingBtn: true})
    const response = await rejectUpload({...data, justification});
    if (!response?.status) {
      this.setState({showModalDetailUpload: {isVisible: false}})
      this.setState({loading: true})
      const dataBitacora = {
        transactionName: 'suspCargaMasivaInt',
        reason: `${getValueLanguageObj(JSON.stringify(data.pais), LANGUAGE_DEFAULT)} - ${data.empresa} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      
      this.loadData()
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
      return this.setState({loading: false, loadingBtn: false});
    }
    this.setState({loadingBtn: false})
  }

  onReactiveUpload = async (data, justification) => {
    const { t, executeUpload, sendActionToBitacora } = this.props
    this.setState({loadingBtn: true})
    const response = await executeUpload({...data, justification});
    if (!response?.status) {
      this.setState({showModalDetailUpload: {isVisible: false}})
      this.setState({loading: true})
      const dataBitacora = {
        transactionName: 'ejecCargaMasivaInt',
        reason: `${getValueLanguageObj(JSON.stringify(data.pais), LANGUAGE_DEFAULT)} - ${data.empresa} || ${justification}`,
      }
      await sendActionToBitacora(dataBitacora)
      this.loadData()
      this.toast.show({
        severity: 'success',
        summary: t('Confirmación'),
        detail: t('La operación se ha realizado de manera éxitosa'),
        life: 3000,
      });
      return this.setState({loading: false, loadingBtn: false});
    }
    this.setState({loadingBtn: false})
  }

  onChangeBtnLoading = (value) => {
    this.setState({loadingBtn: value})
  }

  render() {
    const { t, history, countriesCurrentCatalog } = this.props
    const {
      showModal,
      users,
      lazyParams,
      totalRecords,
      loading,
      typeCountry,
      typeStatus,
      typeCompany,
      catalogCompanies,
      countryRequired,
      showModalDetailUpload,
      companyRequired,
      loadingBtn
    } = this.state;

    const footerModal = (
      <div>
        {showModal.actionOk && (
          <Button label={showModal.textOk} onClick={showModal.actionOk} />
        )}
        {showModal.actionHide && (
          <Button label={showModal.textHide} onClick={showModal.actionHide} />
        )}
      </div>
    );

    const rightHeader = (
      <>
        <Button
          icon="pi pi-angle-left"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/users/internal')}
        />
        <Button
          label={t('Configurar carga')}
          className="p-button-primary"
          onClick={() => history.push('/users/internal/import')}
        />
      </>
    );

    const headerTable = (
      <div className="p-grid">
        <div className="p-col-12 p-md-3 p-lg-3 p-d-flex p-ai-center">
          <label className="p-mr-2 p-text-bold">{t('País')}:</label>
          <Dropdown
            name="typeCountry"
            value={typeCountry}
            options={countriesCurrentCatalog}
            onChange={this.onChange}
            optionLabel="label"
            filter
            showClear
            filterBy="label"
            placeholder=""
            style={{ width: '100%' }}
            className={classNames({
              'p-invalid': countryRequired,
            })}
          />
        </div>
        <div className="p-col-12 p-md-3 p-lg-3 p-d-flex p-ai-center">
          <label className="p-mr-2 p-text-bold">{t('Empresa')}:</label>
          <Dropdown
              name="typeCompany"
              value={typeCompany}
              options={catalogCompanies}
              onChange={this.onChange}
              optionLabel="label"
              filter
              // showClear
              filterBy="label"
              placeholder=""
              style={{ width: '100%' }}
              disabled={!typeCountry}
              className={classNames({
              'p-invalid': companyRequired,
            })}
            />
        </div>
        <div className="p-col-12 p-md-3 p-lg-3 p-d-flex p-ai-center">
          <label className="p-mr-2 p-text-bold">{t('Estatus')}:</label>
          <Dropdown
              name="typeStatus"
              value={typeStatus}
              options={this.catalogStatus}
              onChange={this.onChange}
              optionLabel="label"
              filter
              showClear
              filterBy="label"
              placeholder=""
              style={{ width: '100%' }}
            />
        </div>
        <div className="p-col-12 p-md-3 p-lg-3 p-d-flex p-ai-center p-flex-column p-flex-sm-row p-jc-sm-center ">
          <div className="p-col is-full-width">
            <Button
              icon="pi pi-search"
              label={t('Buscar')}
              className="p-button-raised p-button-text p-button-plain btn-search-list"
              onClick={() => this.searchData()}
            />
          </div>
        </div>
      </div>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Carga masiva de usuarios internos')} rightComponent={rightHeader} />
          <div className="card">
            <div className="p-grid">
              <div className="p-col-12">
                <DataTable
                  value={users}
                  lazy
                  // paginator
                  first={lazyParams.first}
                  // rows={10}
                  // totalRecords={totalRecords}
                  onPage={this.onPage}
                  onSort={this.onSort}
                  loading={loading}
                  header={headerTable}
                  className="table-bulk-load"
                >
                  <Column header={t("Fecha de carga")} body={this.uploadDateTemplate} />
                  <Column header={t("País")} body={this.countryTemplate} />
                  <Column
                    field="empresa"
                    header={t("Empresa")}
                    body={this.columnResponsive}
                    className="column-max"
                  />
                  <Column header={t("Estatus")} body={this.statusTemplate} />
                  <Column field="total" header={t("Registros")} body={this.columnResponsive} />
                  <Column field="altas" header={t("Altas")} body={this.columnResponsive} className="column-action" />
                  <Column field="bajas" header={t("Bajas")} body={this.columnResponsive}  className="column-action"/>
                  <Column field="actualiza" header={t("Actualiza")} body={this.columnResponsive} />
                  <Column field="error" header={t("Con error")} body={this.columnResponsive} className="column-action" />
                  <Column header={t("Detalle")} body={this.detailTemplate} className="column-action p-text-center-lg"/>
                </DataTable>
              </div>
              { !users.length && (
                <div className="p-col-12 not-information">
                  {t('No se encontraron resultados')}
                </div>
              )
              }
            </div>
          </div>
        </div>
        { showModalDetailUpload.isVisible && (
          <DetailUploadModal
            onHidden={() => this.setState({showModalDetailUpload: {isVisible: false}})}
            data={showModalDetailUpload.data}
            suspendAction={this.onSuspendUpload}
            reactiveAction={this.onReactiveUpload}
            loadingBtn={loadingBtn}
            onChahneLoadingBtn={this.onChangeBtnLoading}
          />
        )}
        <Dialog
          header={showModal.title}
          visible={showModal.isVisible}
          breakpoints={{'960px': '90vw'}}
          style={{ width: '35vw' }}
          footer={footerModal}
          onHide={showModal.actionHide}
        >
          {showModal.children}
        </Dialog>
        <Toast ref={(el) => (this.toast = el)} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  countriesCurrentCatalog: getAllowedCountries(state.catalogs.countriesCurrentCatalog, state.sessionPermission),
  canViewAllCountries: canNavigateAllCountries(state.sessionPermission),
});

const mapDispatchToProps = {
  getListInternalUserLoads,
  getTotalBulkLoad,
  getDetailLoadInternal,
  getBusiness,
  executeUpload,
  rejectUpload,
  sendActionToBitacora
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
  )(BulkLoadInternals);
